export const MOBILE_BUTTON_SIZE = 52;
export const DESKTOP_BUTTON_SIZE = 60;

export const PHONE_INPUT_LABEL = 'Введите номер телефона';

export const MAX_MOBILE_NUMBER_CHAR_COUNT = 12;
